// extracted by mini-css-extract-plugin
export default {"content":"ivw9atkMME","message-icon":"_1YT3Y3hpsC","messageIcon":"_1YT3Y3hpsC","not-available":"LMi-btQ6iP","notAvailable":"LMi-btQ6iP","messages":"XeH+x9Eztw"};